/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const IpmGroupDTO = {
    NONE: 'NONE',
    A: 'A',
    B: 'B',
    C: 'C',
    D: 'D',
    X: 'X'
} as const;
export type IpmGroupDTO = typeof IpmGroupDTO[keyof typeof IpmGroupDTO];

